const formatCampaignForTextSelect = (campaignToFormat) => ({
  value: campaignToFormat.campaignId,
  text: campaignToFormat.displayName || campaignToFormat.name,
});

export { formatCampaignForTextSelect };
